<template>
  <div class="box box_mm">
    <div class="box_main">
      <div class="search_box">
        <div class="search_item">
          <span style="width: 0.8rem">标题：</span>
          <el-input
            v-model="searchinput"
            placeholder="请输入"
            style="width: 2rem"
          ></el-input>
        </div>
        <div class="search_item">
          <span style="width: 0.8rem">分类：</span>
          <el-select
            v-model="searchfenlei"
            placeholder="请选择"
            filterable
            clearable
            style="width: 2.3rem"
            @change="search"
          >
            <el-option
              v-for="item in classifyData"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </div>
        <div class="search_item">
          <el-button type="primary" @click="search">搜索</el-button>
          <!-- <el-button type="success" @click="addnew">新建公文处理单</el-button> -->
        </div>
      </div>
      <div class="box_cont">
        <div class="btn_list"></div>
        <div style="height: 76vh; box-sizing: border-box">
          <MyTable
            ref="zjlist"
            :tableData="tableData"
            :tableHeader="tableHeader"
            :showbm="true"
            :czwidth="390"
            @getdata="gettable"
            @changswitch="changswitch"
          >
            <template slot="btns" slot-scope="{ scope }">
              <el-button
                @click="showdetail2(scope.row)"
                type="primary"
                size="mini"
                >详情</el-button
              >
              <el-button
                @click="showdetail(scope.row)"
                type="primary"
                size="mini"
                >查看文件</el-button
              >
              <el-button @click="bohui(scope.row)" type="warning" size="mini"
                >驳回</el-button
              >
              <el-button @click="pass(scope.row)" type="success" size="mini"
                >接收</el-button
              >
              <el-button
                @click="openEidtType(scope.row)"
                type="warning"
                size="mini"
                >修改分类</el-button
              >
            </template>
          </MyTable>
        </div>
      </div>
    </div>

    <!--审核-->
    <el-dialog
      title="审核通过"
      :visible.sync="yjshow"
      width="40%"
      :before-close="closeyj"
      :destroy-on-close="true"
    >
      <div>
        <el-form
          ref="yjform"
          :model="yjform"
          :rules="yjrules"
          label-width="100px"
        >
          <el-form-item label="批示内容" prop="sh_opinion">
            <el-input
              type="textarea"
              :rows="4"
              placeholder="请输入"
              v-model="yjform.sh_opinion"
            >
            </el-input>
          </el-form-item>
          <!-- <el-form-item label="承办单位" prop="jbusers">
            <el-button size="small" type="primary" @click="selectdw(1)"
              >选择</el-button
            >
            <div>
              <span
                >已选人员：<span v-for="item in yjform.jbusers_name"
                  >{{ item }};</span
                ></span
              >
            </div>
          </el-form-item> -->
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeyj">取 消</el-button>
        <el-button type="primary" @click="qryj">接 收</el-button>
      </span>
    </el-dialog>

    <!--修改分类-->
    <el-dialog
      title="修改分类"
      :visible.sync="showEidtType"
      width="25%"
      :before-close="colseShowEidtType"
    >
      <div>
        <el-select
          v-model="sqmytype_name"
          placeholder="请选择"
          filterable
          clearable
          style="width: 100%"
        >
          <el-option
            v-for="item in classifyData"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="colseShowEidtType">取 消</el-button>
        <el-button type="warning" @click="queren">确 定</el-button>
      </span>
    </el-dialog>

    <detail
      v-if="showtcdetail"
      :id="nowid"
      @closedetail="showtcdetail = false"
    ></detail>

    <detail_tcsj
      v-if="showtcsjdetail"
      :id="nowid"
      @closedetail="showtcsjdetail = false"
    ></detail_tcsj>
    <selectcbdw ref="myselectcbdw" @selectedry="selecteddw"></selectcbdw>
  </div>
</template>

<script>
import selectcbdw from "@/components/select_cbdw.vue";
import detail from "./detail_tc";
import detail_tcsj from "./detail_tcsj";

export default {
  components: {
    detail,
    detail_tcsj,
    selectcbdw,
  },
  data() {
    return {
      searchinput: "",
      searchfenlei: "",
      tableHeader: [
        {
          prop: "id",
          name: "序",
          width: "50",
        },
        {
          prop: "name",
          name: "标题",
          width: "",
        },
        {
          prop: "sqmytype_name",
          name: "所属类别",
          width: "150",
        },
        {
          prop: "sqmychannel_name",
          name: "来源渠道",
          width: "150",
        },
        {
          prop: "user_name",
          name: "发起人",
          width: "120",
        },
        {
          prop: "gbtype",
          name: "是否挂办",
          width: "120",
        },
        {
          prop: "state",
          name: "状态",
          width: "120",
          type: "sqmy_type",
        },
        {
          prop: "createtime",
          name: "创建时间",
          width: "150",
        },
      ],
      tableData: [],
      showtcdetail: false,
      showtcsjdetail: false,
      nowid: "",

      yjrules: {
        sh_opinion: [
          {
            required: true,
            message: "请输入",
            trigger: "change",
          },
        ],
        blusers: [
          {
            required: true,
            message: "请选择",
            trigger: "change",
          },
        ],
      },
      yjshow: false,
      yjform: {
        id: "",
        // jbusers: "",
        // jbusers_name: "",
        sh_opinion: "",
      },

      showEidtType: false,
      classifyData: [],
      sqmytype_name: "",
    };
  },
  mounted() {
    this.$post({
      url: "/api/sqmytype/index",
      params: {
        p: 1,
        size: 9999,
      },
    }).then((res) => {
      this.classifyData = res.list;
    });
    this.gettable();
  },
  methods: {
    queren() {
      this.$post({
        url: "/api/sqmy/xgfl",
        params: {
          id: this.nowid,
          sqmytype_id: this.sqmytype_name,
        },
      }).then((res) => {
        this.$message({
          type: "success",
          message: "操作成功!",
        });
        this.colseShowEidtType();
        this.gettable();
      });
    },
    openEidtType(row) {
      this.nowid = row.id;
      this.showEidtType = true;
    },
    colseShowEidtType() {
      this.nowid = "";
      this.showEidtType = false;
    },
    closeyj() {
      this.yjform = {
        id: "",
        // jbusers: "",
        // jbusers_name: "",
        sh_opinion: "",
      };
      this.yjshow = false;
    },
    qryj() {
      this.$refs.yjform.validate((valid) => {
        if (valid) {
          // this.yjform.jbusers = this.yjform.jbusers.join(",");
          // this.yjform.jbusers_name =
          //   this.yjform.jbusers_name.length > 0
          //     ? this.yjform.jbusers_name.join(",")
          //     : "";

          this.yjform.id = this.nowid;
          this.$post({
            url: "/api/sqmy/zfbtguo",
            params: {
              ...this.yjform,
            },
          }).then((res) => {
            this.$message({
              type: "success",
              message: "操作成功!",
            });
            this.closeyj();
            this.gettable();
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    selecteddw(e) {
      this.yjform.jbusers = e.map((item) => {
        return item.id;
      });
      this.yjform.jbusers_name = e.map((item) => {
        return item.name;
      });
      // this.yjform.jbusers = this.yjform.jbusers.join(",");
      // this.yjform.jbusers_name = this.yjform.jbusers_name.join(",");
    },
    selectdw(iii) {
      this.yjform.id = iii.id;
      let cxidlist = "";
      let cxnamelist = "";
      cxidlist = JSON.parse(JSON.stringify(this.yjform.jbusers));
      cxnamelist = JSON.parse(JSON.stringify(this.yjform.jbusers_name));
      this.$refs.myselectcbdw.isdanxuan = false;
      let list = [];
      if (cxnamelist.length > 0) {
        cxidlist.forEach((item, index) => {
          let obj = {
            name: cxnamelist[index],
            id: Number(item),
          };
          list.push(obj);
        });
      }
      this.$refs.myselectcbdw.selectuser = list;
      this.$refs.myselectcbdw.organizational_pid = 11;
      this.$refs.myselectcbdw.dialogVisible = true;
    },
    showdetail2(row) {
      this.nowid = row.id;
      this.showtcsjdetail = true;
    },
    bohui(row) {
      this.$prompt("请输入驳回理由", "提示", {
        confirmButtonText: "驳回",
        cancelButtonText: "取消",
        inputPattern: /\S/,
        inputErrorMessage: "请输入理由",
      })
        .then(({ value }) => {
          this.$post({
            url: "/api/sqmy/zfbbohui",
            params: {
              id: row.id,
              sh_opinion: value,
            },
          }).then((res) => {
            this.$message({
              type: "success",
              message: "操作成功!",
            });
            this.gettable();
          });
        })
        .catch(() => {});
    },
    pass(row) {
      this.nowid = row.id;
      this.yjshow = true;
      // this.$prompt("请输入批示内容", "提示", {
      //   confirmButtonText: "通过",
      //   cancelButtonText: "取消",
      //   inputPattern: /\S/,
      //   inputErrorMessage: "请输入",
      // })
      //   .then(({ value }) => {
      //     this.$post({
      //       url: "/api/sqmy/zfbtguo",
      //       params: {
      //         id: row.id,
      //         sh_opinion: value,
      //       },
      //     }).then((res) => {
      //       this.$message({
      //         type: "success",
      //         message: "操作成功!",
      //       });
      //       this.gettable();
      //     });
      //   })
      //   .catch(() => {});
    },
    showdetail(row) {
      this.nowid = row.id;
      this.showtcdetail = true;
    },
    postdata(row) {},
    showeidt(row) {
      this.$router.push("/system/get_file/edit?id=" + row.id);
    },
    changswitch(row) {
      this.$post({
        url: "/api/room/edit",
        params: row,
      }).then((res) => {
        this.$message({
          type: "success",
          message: "操作成功!",
        });
        this.gettable();
      });
    },
    search() {
      this.$refs.zjlist.inputpage = 1;
      this.gettable();
    },
    gettable() {
      this.$post({
        url: "/api/sqmy/quanindex",
        params: {
          name: this.searchinput,
          p: this.$refs.zjlist.inputpage,
          sqmytype_id: this.searchfenlei,
          state: 4,
          size: this.$refs.zjlist.pagesize,
        },
      }).then((res) => {
        res.list.map((item) => {
          item.gbtype = item.gbtype == 2 ? "挂办" : "";
          return item;
        });
        this.tableData = res.list;
        this.$refs.zjlist.total = res.count;
      });
    },
    addnew() {
      this.$router.push("/system/get_file/add");
    },
    showdate(row) {
      this.$refs.myroomdate.dialogVisible = true;
    },
    onCreated(editor) {
      this.editor = Object.seal(editor); // 一定要用 Object.seal() ，否则会报错
    },
  },
  beforeDestroy() {
    const editor = this.editor;
    if (editor == null) return;
    editor.destroy(); // 组件销毁时，及时销毁编辑器
  },
};
</script>

<style lang="scss" scoped>
@import "list.scss";
</style>
